<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div >


 
     <vs-table
        :sst="true"
        :data="dataTransformed">
          <div slot="header" class="w-full">
       
            <div class="flex flex-wrap-reverse items-center">

              <!-- Search -->
              <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-warning border border-solid border-warning" @click="searchPrompt = true">
                  <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2 text-base">Search/Filter</span>
              </div>

              <vs-prompt
                title="Search"
                @cancel="val=''"
                @accept="searchQuery"
                @close="searchPrompt = false"
                :active.sync="searchPrompt">

                <div class="con-exemple-prompt">
					<p v-if="searchError" class="text-danger mb-3">
						There was an error while searching. Please try again.
					</p>
                  <span>Enter an account name to search by..</span>
                  <vue-simple-suggest v-model="accountQuery" display-attribute="name" value-attribute="id" :min-length="3"
                  :prevent-submit="true" :max-suggestions="10" :controls="{
                    selectionUp: [38, 33],
                    selectionDown: [40, 34],
                    select: [13, 36],
                    hideList: [27, 35]
                  }" :nullable-select="false" :list="getSuggestionList" @select="onSuggestSelect"></vue-simple-suggest>


                  <div class="mt-4">Enter a Truck name or License Plate to search</div>
                  <vs-input @keyup.enter="searchQuery" placeholder="Enter search query..." vs-placeholder="Big Truck,ABC123,..." v-model="search.query" class="w-full" />
                </div>
              </vs-prompt>


            </div>

            <div class="flex justify-between py-3 px-4 rounded" style="background:#eee" v-if="searchedTerm.query.trim() || searchedTerm.accountObj.id">
				<span> Showing {{searchResults.length}} results for <b>{{searchedString}}</b> </span>
				<vs-button size="small" color="warning" @click.native="clearSearch">Clear Search</vs-button>
            </div>

          </div>

            <template slot="thead">
                <vs-th >Name</vs-th>
                <vs-th >Lic. Plate#</vs-th>
                <vs-th>Account</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    
                    <vs-td :data="data[indextr].name">
                        {{ data[indextr].name }}
                    </vs-td>
                    <vs-td :data="data[indextr].licPlate">
                        {{ data[indextr].licPlate }}
                    </vs-td>
                    <vs-td>
                        <router-link :to="`/account/${tr.account.id}`" class="product-name font-medium">{{ tr.account.name }}</router-link>
                    </vs-td>
                </vs-tr>
            </template>
    </vs-table>
    <vs-pagination class="mt-3" :total="total" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
import DataSidebar from '@/components/DataSidebar.vue';
import {arrToObj,notify,permissionFail,$loading} from '@/assets/helper'
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
export default {
    components: {
        DataSidebar,VueSimpleSuggest,
    },
    data() {
        return {
			searchError:false,
            searchPrompt:false,
            search:{
				query:'',
				account:'',
				accountObj:{},
			},
			accountQuery: "",
            currentPage:1,
            totalTrucks:0,
            searchedTerm:{
				query:'',
				accountObj:{}
			},
            searchResults:[],
            trucks:[],
            selected: [],
            itemsPerPage: 10,
            isMounted: false,
            addNewDataSidebar: false,
        }
    },
    watch:{
        searchPrompt(val){
			console.log('CLEARINGGGGGGG serch')
			if (val){
				this.search.query = ''
				this.search.accountObj = {}
			}
        },
        currentPage:{
            immediate:true,
            async handler(val){
                console.log('STARTINGGGGG ACCOUNTS')
                $loading()
                
                if (!this.totalAccounts){

                    try{
                        let {data} = await this.$get(`/trucks/count`)
                        this.totalTrucks = data    
                    }catch(err){
                        console.error('something happened')
                    }
                    
                }

                let start = this.limit * (val-1) 
                let params = '' 
                if (this.sort) params += `_sort=${this.sort}&`
                if (this.limit) params += `_start=${start}&_limit=${this.limit}`
                let {data} = await this.$get(`/trucks?${params}`)
                this.trucks = data
                $loading.close()
            }
        }
    },
    computed: {
		searchedString(){
			let string = ''
			if (this.searchedTerm.query.trim()) string += `Truck Name/Lic.Plate containing ${this.searchedTerm.query.trim()}`
			if (this.searchedTerm.query.trim() && this.searchedTerm.accountObj.id) string += ' and '
			if (this.searchedTerm.accountObj.id) string += `Account: ${this.searchedTerm.accountObj.name}`
			return string
		},
        dataTransformed(){
          if (this.searchedTerm.query || this.searchedTerm.accountObj.id) return this.searchResults 
          return this.trucks
        },
        total(){
            let totalTrucks = this.totalTrucks
            let limit = this.limit 
            return Math.ceil(totalTrucks / limit)
        },
        sort(){
            return this.$route.meta.sort || ''
        },
        limit(){
            return this.$route.meta.limit || 10
        },
      
    },
    methods: {
        clearSearch(){
			console.log('CLEARINGGGGGGG FILTER')
			this.search.query = ''	
			this.search.accountObj = {}
			this.accountQuery = ''
			this.searchedTerm = {
				query:'',
				accountObj:{}
			}

        },
        async getSuggestionList() {

          let { data } = await this.$get( `/accounts?name_contains=${this.accountQuery}`);
          return data;

        },
        onSuggestSelect(suggest) {
          this.search.accountObj = suggest;
        },
        boldenSuggestion(scope) {
          if (!scope) return scope;
          const {
          suggestion,
          query
          } = scope;
          let result = this.$refs.suggestComponent.displayProperty(suggestion);
          if (!query) return result;
          const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [""];
          return result.replace(
          new RegExp("(.*?)(" + texts.join("|") + ")(.*?)", "gi"),
          "$1<b>$2</b>$3"
          );
        },
        searchQuery(){
			this.searchError = false
			if (!this.search.query.trim() && !this.search.accountObj.id) return this.searchPrompt = false
			$loading()
			let query = this.search.query

		  	let params = '' 
			let qI = 0
			

			if (!query.trim()){
				params = `account=${this.search.accountObj.id}`
			} else {
				params = `_where[_or][0][licPlate_contains]=${query}&_where[_or][1][name_contains]=${query}`
				if (this.search.accountObj.id && this.accountQuery.trim()) params += `_where[_or][2][account]=${this.search.accountObj.id}`
			}
			console.log('this ==>', this.search.query,'=>',query)

          	let url = `/trucks?${params}`
			this.$get(url).then( ({data}) => {
				console.log('this.searchedTermthis.searchedTerm',this.search.query,'=>',query)
				this.searchResults = data
				this.searchedTerm = JSON.parse(JSON.stringify(this.search))
				// this.searchPrompt = false
			})
			.catch( () => {
				this.searchError = true
			})
			.finally( () => {
				$loading.close()
			})
        },
        handleSearch(e,f){
            console.log('HANDLDING SEARCH',e,f)
        },
    
    },
    created() {
        
    },
    mounted() {
        this.isMounted = true;
    }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
